"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
function isExternalUrl(url) {
    // Assumes absolute urls will always begin with `http(s)`
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
        return new URL(url).hostname !== window.location.hostname;
    }
    return false;
}
exports.isExternalUrl = isExternalUrl;
class Link extends React.Component {
    constructor() {
        super(...arguments);
        this.onClick = (event) => {
            if (this.props.onClick) {
                this.props.onClick(event);
            }
        };
    }
    render() {
        const { title, children, to, className } = this.props;
        return isExternalUrl(to) ? (React.createElement("a", { className: className, href: to, onClick: this.onClick, target: "_blank" }, title || children)) : (React.createElement(react_router_dom_1.Link, { className: className, to: to, onClick: this.onClick }, title || children));
    }
}
exports.Link = Link;
